//notifications list
window.NotificationsList = function() {
	return {
		//model
		state: {
			notifications : [],
			pagination: {
				has_more_items: null,
				next_url: null
			},
			isInQuerying: false
		},
		setState: function(state) {
			for (var key in state) {
				if (!this.state.hasOwnProperty(key)) {
					continue;
				}

				this.state[key] = state[key];
			}

			this.render();
		},
		//view handle
		el: $(".notifications-list"),
		isInListEnd: function() {
	        if ( ($(this.el).scrollTop() + $(this.el).height()) < $(this.el)[0].scrollHeight ) {
	            return false;
	        }

	        return true;
	    },
		preventParentScrolling: function() {
			var isMac = (navigator.userAgent.indexOf("Macintosh") !== -1);
			var isFirefox = (navigator.userAgent.toLowerCase().indexOf("firefox") !== -1);

			// prevent from scrolling parrent elements
			function wheelHandler(event) {
				var e = event || window.event;  // Standard or IE event object

				// Extract the amount of rotation from the event object, looking
				// for properties of a wheel event object, a mousewheel event object
				// (in both its 2D and 1D forms), and the Firefox DOMMouseScroll event.
				// Scale the deltas so that one "click" toward the screen is 30 pixels.
				// If future browsers fire both "wheel" and "mousewheel" for the same
				// event, we'll end up double-counting it here. Hopefully, however,
				// cancelling the wheel event will prevent generation of mousewheel.
				var deltaY = e.deltaY * -30 || e.wheelDeltaY / 4 || (e.wheelDeltaY === undefined && e.wheelDelta / 4) || e.detail * -10 || 0;

				// Most browsers generate one event with delta 120 per mousewheel click.
				// On Macs, however, the mousewheels seem to be velocity-sensitive and
				// the delta values are often larger multiples of 120, at
				// least with the Apple Mouse. Use browser-testing to defeat this.
				if (isMac) {
					deltaY /= 30;
				}

				var target = (e.currentTarget) ? e.currentTarget : e.srcElement;
				target.scrollTop -= deltaY;

				// If we ever get a mousewheel or wheel event in (a future version of)
				// Firefox, then we don't need DOMMouseScroll anymore.
				if (isFirefox && e.type !== "DOMMouseScroll") {
					$(this)[0].removeEventListener("DOMMouseScroll", wheelHandler, false);
				}

				// Don't let this event bubble. Prevent any default action.
				// This stops the browser from using the mousewheel event to scroll
				// the document. Hopefully calling preventDefault() on a wheel event
				// will also prevent the generation of a mousewheel event for the
				// same rotation.
				if (e.preventDefault) e.preventDefault();
				if (e.stopPropagation) e.stopPropagation();
				e.cancelBubble = true;  // IE events
				e.returnValue = false;  // IE events
				return false;
			}

			// Register mousewheel event handlers.
	        $(this.el)[0].addEventListener('wheel', wheelHandler, { passive: false });       // Future browsers
	        $(this.el)[0].addEventListener('mousewheel', wheelHandler, { passive: false });  // Most current browsers
	        if (isFirefox) {              // Firefox only
	            $(this.el)[0].scrollTop = 0;
	            $(this.el)[0].addEventListener("DOMMouseScroll", wheelHandler, false);
	        }
		},
		timeAgoFormat: function(iso8601) {
			var timeAgoWords = {
				seconds: "%d秒前",
				minute: "1分鐘前",
				minutes: "%d分鐘前",
				hour: "1小時前",
				hours: "%d小時前",
				day: "昨天"
			};

			var dateString = $.trim(iso8601);
			dateString = dateString.replace(/\.\d+/,""); // remove milliseconds
			dateString = dateString.replace(/-/,"/").replace(/-/,"/");
			dateString = dateString.replace(/T/," ").replace(/Z/," UTC");
			dateString = dateString.replace(/([\+\-]\d\d)\:?(\d\d)/," $1$2"); // -04:00 -> -0400
			dateString = dateString.replace(/([\+\-]\d\d)$/," $100"); // +09 -> +0900

			var pastDateObj = new Date(dateString);
			var currentDateObj = new Date();
			var distanceMillis = currentDateObj.getTime() - pastDateObj.getTime();
			var seconds = Math.abs(distanceMillis) / 1000;
			var minutes = seconds / 60;
			var hours = minutes / 60;
			var days = hours / 24;

			var words = "";
			if (seconds < 45) {
				words = timeAgoWords.seconds.replace(/%d/i, Math.round(seconds));
			} else if (seconds < 90) {
				words = timeAgoWords.minute;
			} else if (minutes < 45) {
				words = timeAgoWords.minutes.replace(/%d/i, Math.round(minutes));
			} else if (minutes < 90) {
				words = timeAgoWords.hour;
			} else if (hours < 24) {
				words = timeAgoWords.hours.replace(/%d/i, Math.round(hours));
			} else if (hours < 42) {
				words = timeAgoWords.day;
			} else {
				var dateArray = iso8601.split("+")[0].split("T");
				dateArray = dateArray[0].split("-").concat(dateArray[1].split(":"));

				words = [
					currentDateObj.getFullYear() === parseInt(dateArray[0]) ? "" : [dateArray[0], "年"].join(""),
					parseInt(dateArray[1]), "月",
					parseInt(dateArray[2]), "日 ",
					dateArray[3], ":",
					dateArray[4]
				].join("");
			}

			return words;
		},
		emptyHintBoilerplate: function() {
			return [
				"<div class='notifications-empty-hint'>",
					"<i class='notifications-empty-hint-icon icon-font-bell'></i> 目前沒有任何通知",
				"</div>"
			].join("");
		},
		notificationBoilerplate: function(notification) {
			var isEventTypePodcastAD = notification.event_type === 'PODCAST_ADVERTISEMENT'
			var readStateClassName = notification.read ? "" : "is-unread";

			var avatar = notification.actor && !notification.actor.guest
				? ["<img class='notification-avatar' src='", notification.actor.avatar_url, "' />"].join("")
				: "<div class='notification-avatar notification-avatar-guest'>訪</div>";


			var content = "";
			switch (notification.event_type) {
				case "PODCAST_ADVERTISEMENT":
					content = [
						'財報狗 Podcast 新集數上線：',
						'<b>', notification.subject.podcast_episode_title, '</b>'
					].join('')
					break;
				case "NEW_INSIGHT_POST_RELATED_TO_MY_TRACKING_STOCKS":
					var relatedStockName = "你追蹤過的公司";
					if (notification.related_stocks.length > 0) {
						relatedStockName = notification.related_stocks[0].name;
					}

					content = [
						"<b>", notification.actor.name, "</b> ",
						"發表了一篇和", relatedStockName, "有關的洞見文章：<b>", notification.subject.title, "</b>"
					].join("");
					break;
				case "STATEMENTDOG_APPROVED_MY_INSIGHT_POST":
					content = [
						"恭喜你！你的文章：<b>", notification.subject.title, "</b> 已經發佈在洞見上，",
						"你將獲得2個月的閱讀精選文章與參加洞見聚會權限"
					].join("");
					break;
				case "STATEMENTDOG_APPROVED_MY_INSIGHT_POST_WITH_TOP_LEVEL":
					content = [
						"恭喜你！你的文章：<b>", notification.subject.title, "</b> 被選為洞見精選文章，",
						"你將獲得6個月的閱讀精選文章與參加洞見聚會權限"
					].join("");
					break;
				case "USER_LIKED_MY_INSIGHT_POST":
					content = [
						"<b>", notification.actor.name, "</b> ",
						"推薦了你的文章：<b>", notification.subject.title, "</b>"
					].join("");
					break;
				case "USER_LIKED_MY_INSIGHT_COMMENT":
					content = [
						"<b>", notification.actor.name, "</b> ",
						"推薦了你的一則留言：「", notification.subject.content, "」"
					].join("");
					break;
				case "USER_COMMENTED_ON_MY_INSIGHT_POST":
					content = [
						"<b>", notification.actor.name, "</b> ",
						"回覆了你發表的一篇文章：<b>", notification.subject.title, "</b>"
					].join("");
					break;
				case "USER_COMMENTED_ON_MY_COLLECTED_INSIGH_POST":
					content = [
						"<b>", notification.actor.name, "</b> ",
						"回覆了你收藏的一篇文章：<b>", notification.subject.title, "</b>"
					].join("");
					break;
				case "USER_COMMENTED_ON_INSIGH_POST_COMMENTED_BY_ME":
					content = [
						"<b>", notification.actor.name, "</b> ",
						"回覆了你留言過的一篇文章：<b>", notification.subject.title, "</b>"
					].join("");
					break;
				default:

			}

			return isEventTypePodcastAD ?
				[
					'<span class="notification is-podcast-type ', readStateClassName, '"',
						' data-episode-title="', notification.subject.podcast_episode_title, '"',
						' data-notification-id="', notification.id, '">',
						'<div class="notification-avatar notification-avatar-statementdog">',
							'<svg><use xlink:href="#svg-icon-statementdog-logo"></use></svg>',
						'</div>',
						'<div class="notification-content">',
							content, '<br/>',
							'<span class="notification-date">', this.timeAgoFormat(notification.created_at), '</span>',
							'<div class="notification-podcast-cta">',
        						'<a class="notification-podcast-cta-button"',
          							' href="', notification.subject.apple_podcast_episode_url, '"',
          							' target="_blank">',
									'<span class="notification-podcast-cta-icon">',
										'<svg><use xlink:href="#svg-icon-apple-podcast-color"></use></svg>',
									'</span>',
									'到 Apple Podcast 收聽',
								'</a>',
								'<a class="notification-podcast-cta-button"',
          							' href="', notification.subject.spotify_episode_url, '"',
          							' target="_blank">',
									'<span class="notification-podcast-cta-icon">',
										'<svg><use xlink:href="#svg-icon-spotify-color"></use></svg>',
									'</span>',
									'到 Spotify 收聽',
								'</a>',
      						'</div>',
						'</div>',
					'</span>'
				].join('') :
				[
					"<a class='notification ", readStateClassName, "'",
						" data-notification-id='", notification.id, "'",
						" href='", notification.subject.url, "'",
						" target='_blank'>",
						avatar,
						"<p class='notification-content'>",
							content, "<br/>",
							"<span class='notification-date'>", this.timeAgoFormat(notification.created_at), "</span>",
						"</p>",
					"</a>"
				].join("");
		},
		render: function() {
			var htmlTxt = "";

			if (this.state.notifications.length === 0) {
				//clear all exist DOM before querying hint node
				$(this.el).find(".notifications-quering-hint").prevAll().remove();

				htmlTxt = this.emptyHintBoilerplate();
			} else {
				var thisObj = this;
				htmlTxt = $.map(this.state.notifications, function(notification, index) {
					var boilerplate = "";
					var correspondElem = $(thisObj.el).children().eq(index);
					//do not re-render existing notifiction
					if (notification.id == correspondElem.attr("data-notification-id")) {
						var readState = !correspondElem.hasClass("is-unread");

						if (readState != notification.read) {
							if (notification.read) {
								correspondElem.removeClass("is-unread");
							} else {
								correspondElem.addClass("is-unread");
							}
						}
					} else {
						boilerplate = thisObj.notificationBoilerplate(notification);
					}

					return boilerplate;
		        }).join("");
			}

			if (htmlTxt !== "") {
				$(this.el).find(".notifications-quering-hint").before(htmlTxt);
			}

			if (this.state.isInQuerying) {
				$(this.el).find(".notifications-quering-hint").show();
			} else {
				$(this.el).find(".notifications-quering-hint").hide();
			}
		},
		//view controller
		getInitNotifications: function() {
			//already has notificaions
			if (this.state.notifications.length !== 0) {
				return;
			}

			var thisObj = this;
			$.ajax({
	            url: "/api/v1/notifications",
	            type: "GET",
	            cache :false,
	            dataType: "json",
	            timeout: 15000,
	            success: function (data, textStatus, jqXHR) {
					//reset state
					thisObj.setState({
						notifications: data.notifications,
						pagination: data.pagination,
						isInQuerying: false
					});
	            },
	            error: function(jqXHR, textStatus, errorThrown) {
					thisObj.setState({
						isInQuerying: false
					});
	            }
	        });
		},
		getMoreNotifications: function() {
			if (this.state.isInQuerying) {
				return;
			}

			this.setState({
				isInQuerying: true
			});

			var thisObj = this;
			$.ajax({
				url: this.state.pagination.next_url,
				type: "GET",
				cache :false,
				dataType: "json",
				timeout: 15000,
				success: function (data, textStatus, jqXHR) {
					//add notifiactions
					var originNotificationsList = thisObj.state.notifications.slice(0);
					var newNotificationsList = originNotificationsList.concat(data.notifications);
					//reset state
					thisObj.setState({
						notifications: newNotificationsList,
						pagination: data.pagination,
						isInQuerying: false
					});
				},
				error: function(jqXHR, textStatus, errorThrown) {
					thisObj.setState({
						isInQuerying: false
					});
				}
			});
		},
		setNotificationToRead: function(notifictionId) {
			var notificationsList = this.state.notifications.slice(0);
			$.each(notificationsList, function( index, notification ) {
				if (notifictionId === notification.id) {
					notification.read = true;
					return false;
				}
			});
			this.setState({notifications: notificationsList});

			$.ajax({
				url: "/api/v1/notifications/" + notifictionId + "/read",
				type: "PATCH",
				cache :false,
				dataType: "json",
				timeout: 15000
			});
		},
		init: function() {
			//check element is existing
			if ($(this.el).length === 0) {
				return;
			}

			//elem event handle
			var thisObj = this;
			$(this.el).scroll(function(e) {
				if (!thisObj.isInListEnd()) {
					return;
				}

				if (!thisObj.state.pagination.has_more_items) {
					return;
				}

				thisObj.getMoreNotifications();
			}).click(function(e) {
				stopPropagation(e);
			}).on("click", ".notification", function(e) {
				var currentTarget = $(e.currentTarget)
				if (currentTarget.hasClass("is-podcast-type")) {
					return;
				}
				if (currentTarget.hasClass("is-unread")) {
					var id = parseInt(currentTarget.attr("data-notification-id"));
					thisObj.setNotificationToRead(id);
				}
				$('body').click()
			}).on('click', '.notification-podcast-cta-button', function(e) {
				var notificationItem = $(e.currentTarget).parents('.notification')
				var contentSource = /Apple Podcast/g.test(e.currentTarget.innerText)
					? 'Apple Podcast' : 'Spotify'

					if (notificationItem.hasClass("is-unread")) {
						thisObj.setNotificationToRead(notificationItem.attr("data-notification-id"));
					}
					window.amplitudeEvents.clickNotification({
						clickedFrom: window.location.href,
						contentType: 'podcast',
						contentSource: contentSource,
						contentTitle: notificationItem.attr('data-episode-title')
					})
			});

			//prevent scroll event bubble up to parent
			this.preventParentScrolling();
		}
	};
};

//notifictions count
window.NotifiactionsCount = function() {
	return {
		//model
		state: {
			count: 0,
			isShow: false
		},
		setState: function(state) {
			for (var key in state) {
				if (!this.state.hasOwnProperty(key)) {
					continue;
				}

				this.state[key] = state[key];
			}

			this.render();
		},
		//view handle
		el: $(".notifications-count"),
		render: function() {
			if (this.state.count === 0) {
				$(this.el).removeClass("is-show");
			} else {
				$(this.el).addClass("is-show");
			}
			$(this.el).text(this.state.count);
		},
		//view controller
		init: function() {
			//check element is existing
			if ($(this.el).length === 0) {
				return;
			}

			var count = parseInt($(".notifications-count").text());
			this.setState({count: count});
		},
		resetCount: function() {
			if (this.state.count === 0){
				return;
			}

			this.setState({count: 0});

			$.ajax({
				url: "/api/v1/notifications/reset_uninspected_count",
				type: "PATCH",
				cache :false,
				dataType: "json",
				timeout: 15000
			});
		}
	};
};
